module.exports = __webpack_public_path__ + "9ec4cc83973eac676c0d4724225dcfe9.pdf";